import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from "react";
import RouterWrapper from './auth';



//NO AUTH
import Login from '../Views/Login';
import RecuperarSenha from '../Views/RecuperacaoSenha'
import Page404 from '../Views/404'
import TrocaEmail from '../Views/TrocaEmail'
import Autenticar from '../Views/AutenticarEmail'


//AUTH
import Dashboard from '../Views/Dashboard';
import Perfil from '../Views/Perfil'



import Usuarios from '../Views/Usuarios'

import ContasRecebimento from '../Views/ContasRecebimento'
import Servicos from '../Views/Servicos'
import Clientes from '../Views/Clientes'
import Faturas from '../Views/Faturas'

import Tecnico from '../Views/Tecnico'
import Logs from '../Views/Tecnico/Logs'
import Requests from '../Views/Tecnico/Requests'


const Router = () => {

    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])


    const RouterTecnico = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Tecnico} isPrivate={false} />} />
                <Route path="/logs" element={<RouterWrapper component={Logs} isPrivate={false} />} />
                <Route path="/requests" element={<RouterWrapper component={Requests} isPrivate={false} />} />
            </Routes>
        )
    }




    return (
        <Routes>
            <Route path="/dashboard" element={<RouterWrapper component={Dashboard} isPrivate={true} />} />
            <Route path="/usuarios" element={<RouterWrapper component={Usuarios} isPrivate={true} />} />
            <Route path="/perfil" element={<RouterWrapper component={Perfil} isPrivate={true} />} />
            <Route path="/tecnicoIndex/*" element={<RouterWrapper component={RouterTecnico} isPrivate={true} />} />
            <Route path="/contasRecebimento" element={<RouterWrapper component={ContasRecebimento} isPrivate={true} />} />
            <Route path="/servicos" element={<RouterWrapper component={Servicos} isPrivate={true} />} />
            <Route path="/clientes" element={<RouterWrapper component={Clientes} isPrivate={true} />} />
            <Route path="/faturas" element={<RouterWrapper component={Faturas} isPrivate={true} />} />

            {/* Rotas públicas */}
            <Route path="/recuperarSenha/:token" element={<RouterWrapper component={RecuperarSenha} isPrivate={false} />} />
            <Route path="/trocarEmail/:token" element={<RouterWrapper component={TrocaEmail} isPrivate={false} />} />
            <Route path="/autenticarEmail/:token" element={<RouterWrapper component={Autenticar} isPrivate={false} />} />
            <Route path="/" element={<RouterWrapper component={Login} isPrivate={false} />} />
            <Route path="*" element={<Page404 />} />
        </Routes>
    )
}

export default Router